import React, { useState, useEffect, useRef } from 'react';
import { useCompanyWorkForce } from '../../context/CompanyWorkForceContext';
import { useCommunicationTemplates } from '../../context/CommunicationTemplatesContext';
import $ from 'jquery';
import 'summernote/dist/summernote-lite.css';
import 'summernote/dist/summernote-lite.js';
import { XMarkIcon, PaperAirplaneIcon } from '@heroicons/react/24/outline';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import { useError } from '../../context/ErrorContext';
import Api from '../../utils/Api';
import { useAuth } from '../../context/AuthContext';
import { useLoading } from '../../context/LoadingContext';

let __roSuppressed = false;
if (typeof window !== 'undefined' && !__roSuppressed) {
  __roSuppressed = true;
  const originalError = console.error;
  const originalWarn = console.warn;
  console.error = (...args) => {
    try {
      const hasResizeObserverMsg = args.some((arg) => {
        if (!arg) return false;
        if (typeof arg === 'string') {
          return (
            arg.includes('ResizeObserver loop completed with undelivered notifications') ||
            arg.includes('ResizeObserver loop limit exceeded')
          );
        }
        if (arg instanceof Error && typeof arg.message === 'string') {
          return (
            arg.message.includes('ResizeObserver loop completed with undelivered notifications') ||
            arg.message.includes('ResizeObserver loop limit exceeded')
          );
        }
        return false;
      });
      if (hasResizeObserverMsg) return;
    } catch (_) {}
    originalError.apply(console, args);
  };
  console.warn = (...args) => {
    try {
      const hasResizeObserverMsg = args.some((arg) => {
        if (!arg) return false;
        if (typeof arg === 'string') {
          return (
            arg.includes('ResizeObserver loop completed with undelivered notifications') ||
            arg.includes('ResizeObserver loop limit exceeded')
          );
        }
        if (arg instanceof Error && typeof arg.message === 'string') {
          return (
            arg.message.includes('ResizeObserver loop completed with undelivered notifications') ||
            arg.message.includes('ResizeObserver loop limit exceeded')
          );
        }
        return false;
      });
      if (hasResizeObserverMsg) return;
    } catch (_) {}
    originalWarn.apply(console, args);
  };
  const windowErrorHandler = (event) => {
    const msg = event?.message || '';
    if (
      typeof msg === 'string' && (
        msg.includes('ResizeObserver loop completed with undelivered notifications') ||
        msg.includes('ResizeObserver loop limit exceeded')
      )
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };
  const unhandledRejectionHandler = (event) => {
    const reason = event?.reason;
    const msg = (typeof reason === 'string') ? reason : (reason?.message || '');
    if (
      typeof msg === 'string' && (
        msg.includes('ResizeObserver loop completed with undelivered notifications') ||
        msg.includes('ResizeObserver loop limit exceeded')
      )
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };
  window.addEventListener('error', windowErrorHandler, true);
  window.addEventListener('unhandledrejection', unhandledRejectionHandler, true);
}

// Wrapper component to handle CKEditor errors (same approach as CommunicationTemplateForm)
// const SafeCKEditor = ({ config, moduleData, onChange, onReady, onError }) => {
//   const [hasError, setHasError] = React.useState(false);

//   if (hasError) {
//     return (
//       <div className="p-4 border border-red-300 rounded-md bg-red-50">
//         <p className="text-red-600">Editor failed to load. Please refresh the page.</p>
//       </div>
//     );
//   }

//   return (
//     <CKEditor
//       editor={ClassicEditor}
//       config={config}
//       data={moduleData}
//       onChange={onChange}
//       onReady={onReady}
//       onError={(error, { willEditorRestart }) => {
//         if (willEditorRestart) {
//           console.warn('Editor will restart due to error:', error);
//         } else {
//           setHasError(true);
//         }
//         if (onError) {
//           onError(error, { willEditorRestart });
//         }
//       }}
//     />
//   );
// };

// Custom upload adapter & plugin to match CommunicationTemplateForm behavior
// class MyUploadAdapter {
//   constructor(loader) {
//     this.loader = loader;
//   }
//   upload() {
//     return this.loader.file.then(
//       (file) => new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.onload = function () {
//           resolve({ default: reader.result });
//         };
//         reader.onerror = function () {
//           reject('Error reading file');
//         };
//         reader.readAsDataURL(file);
//       })
//     );
//   }
//   abort() {}
// }
// function MyCustomUploadAdapterPlugin(editor) {
//   editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
//     return new MyUploadAdapter(loader);
//   };
// }

const SendMailModal = ({ isOpen, onClose, moduleData, module, onSend }) => {
  const { getWorkForce } = useCompanyWorkForce();
  const { getCommunicationTemplates, getCommunicationTemplateById } = useCommunicationTemplates();
  const [tempId,setTempId] = useState(null);
  const summernoteRef = useRef(null);
  const { handleApiError  } = useError();
  const { user, getToken } = useAuth();
  const [api, setApi] = useState(null);
 
  useEffect(() => {
    setApi(Api(() => getToken()));
  
  }, [user, getToken]);

  const [formData, setFormData] = useState({
    from: '',
    bccMe: false,
    to: [''],
    template_id: '',
    body: '',
    subject: '',
    attachments: {
      copy: {
        attachAsPdf: false,
        attachAsExcel: false,
        itemLongText: true,
        itemQuantity: true,
        itemPrice: true,
        itemTotal: true,
        grandTotal: true
      },
      pics: [],
      docs: []
    }
  });

  const [workforce, setWorkforce] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [attachmentsActiveTab, setAttachmentsActiveTab] = useState('copy');
  const fetchDataRef = useRef(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { showLoading, hideLoading } = useLoading();

  // Validation schema
  const schema = yup.object().shape({
    from: yup.string().required('The from field is required.'),
    to: yup
      .array()
      .of(
        yup
          .string()
          .transform((v) => (typeof v === 'string' ? v.trim() : ''))
          .required('The to field is required.')
          .email('The email is invalid.')
      )
      .min(1, 'At least one recipient is required'),
    subject: yup.string().required('The subject field is required.'),
    body: yup.string().required('The body field is required.').test('non-empty', 'The body field is required.', value => {
      const v = (value || '').replace(/<[^>]*>/g, '').trim();
      return v.length > 0;
    })
  });

  const { setValue, formState: { errors }, trigger } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      from: '',
      to: [''],
      subject: '',
      body: ''
    }
  });
    useEffect(() => {
    if (isOpen) {
      const fetchData = async () => {
        try {
          const promises = [
            getWorkForce(0, { active: 1, role: 'manager_supervisor' }),
          ];
      
          if (module === 'job') {
            promises.push(
              getCommunicationTemplates(0, { 
                all: true, 
                active: true,
                communication_template_category_id: [8,9,10,11] 
              })
            );
          } else if (module === 'estimation') {
            promises.push(
              getCommunicationTemplates(0, { 
                all: true, 
                active: true,
                communication_template_category_id: [5, 6] 
              })
            );
          }else if(module === 'invoice'){
            promises.push(
              getCommunicationTemplates(0, { 
                all: true, 
                active: true,
                communication_template_category_id: [13] 
              })
            );
            
          } else {
            promises.push(Promise.resolve({ data: [] })); // fallback
          }
      
          const [workforceData, templatesData] = await Promise.all(promises);
      
          setWorkforce(workforceData?.data || []);
          setTemplates(templatesData?.data || []);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
      

      if(fetchDataRef.current === false){
        fetchData();
        fetchDataRef.current = true;
      }
      
      if(module === 'invoice'){
        const customerEmails = moduleData.job.primary_contact.emails.map(email => email.address);
        setFormData(prev => ({
          ...prev,
          to: customerEmails.length > 0 ? customerEmails : ['']
        }));
        try { setValue('to', customerEmails.length > 0 ? customerEmails : ['']); } catch (_) {}

        moduleData.pictures = moduleData.job?.pictures || [];
        moduleData.documents = moduleData.job?.documents || [];
        
        setFormData(prev => ({
          ...prev,
          attachments: {
            ...prev.attachments,
            pics: moduleData.pictures,
            docs: moduleData.documents
          }
        }));
      }
      
      // Set default "to" emails from customer
      if (moduleData?.primary_contact?.emails) {
        const customerEmails = moduleData.primary_contact.emails.map(email => email.address);
        setFormData(prev => ({
          ...prev,
          to: customerEmails.length > 0 ? customerEmails : ['']
        }));
        try { setValue('to', customerEmails.length > 0 ? customerEmails : ['']); } catch (_) {}
      }
    }
  }, [isOpen, moduleData, getWorkForce, getCommunicationTemplates, getCommunicationTemplateById, setValue,module]);

  // Suppress noisy ResizeObserver errors globally while this modal is mounted
  useEffect(() => {
    const originalError = console.error;
    console.error = (...args) => {
      try {
        const hasResizeObserverMsg = args.some((arg) => {
          if (!arg) return false;
          if (typeof arg === 'string') {
            return (
              arg.includes('ResizeObserver loop completed with undelivered notifications') ||
              arg.includes('ResizeObserver loop limit exceeded')
            );
          }
          if (arg instanceof Error && typeof arg.message === 'string') {
            return (
              arg.message.includes('ResizeObserver loop completed with undelivered notifications') ||
              arg.message.includes('ResizeObserver loop limit exceeded')
            );
          }
          return false;
        });
        if (hasResizeObserverMsg) {
          return;
        }
      } catch (_) {}
      originalError.apply(console, args);
    };

    return () => {
      console.error = originalError;
    };
  }, []);

  // Also silence console.warn variants of the same ResizeObserver message
  useEffect(() => {
    const originalWarn = console.warn;
    console.warn = (...args) => {
      try {
        const hasResizeObserverMsg = args.some((arg) => {
          if (!arg) return false;
          if (typeof arg === 'string') {
            return (
              arg.includes('ResizeObserver loop completed with undelivered notifications') ||
              arg.includes('ResizeObserver loop limit exceeded')
            );
          }
          if (arg instanceof Error && typeof arg.message === 'string') {
            return (
              arg.message.includes('ResizeObserver loop completed with undelivered notifications') ||
              arg.message.includes('ResizeObserver loop limit exceeded')
            );
          }
          return false;
        });
        if (hasResizeObserverMsg) {
          return;
        }
      } catch (_) {}
      originalWarn.apply(console, args);
    };

    return () => {
      console.warn = originalWarn;
    };
  }, []);

  // Capture and stop propagation of ResizeObserver errors at the window level (dev overlay)
  useEffect(() => {
    const handler = (event) => {
      const msg = event?.message || '';
      if (
        typeof msg === 'string' && (
          msg.includes('ResizeObserver loop completed with undelivered notifications') ||
          msg.includes('ResizeObserver loop limit exceeded')
        )
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    };

    window.addEventListener('error', handler, true);
    return () => window.removeEventListener('error', handler, true);
  }, []);

  // Also stop unhandledrejection overlay noise for the same ResizeObserver messages
  useEffect(() => {
    const rejHandler = (event) => {
      const reason = event?.reason;
      const msg = (typeof reason === 'string') ? reason : (reason?.message || '');
      if (
        typeof msg === 'string' && (
          msg.includes('ResizeObserver loop completed with undelivered notifications') ||
          msg.includes('ResizeObserver loop limit exceeded')
        )
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    };

    window.addEventListener('unhandledrejection', rejHandler, true);
    return () => window.removeEventListener('unhandledrejection', rejHandler, true);
  }, []);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Initialize Summernote editor when modal opens
  useEffect(() => {
    if (!isOpen || !summernoteRef.current) return;

    const $el = $(summernoteRef.current);

    $el.summernote({
      placeholder: 'Compose your email here...',
      height: 300,
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'italic', 'underline', 'clear']],
        ['fontstyle', ['fontname', 'fontsize', 'color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link', 'picture', 'video', 'table', 'hr']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      callbacks: {
        onInit: function () {
          $el.summernote('code', formData.body || '');
        },
        onChange: function (contents) {
          setFormData(prev => ({ ...prev, body: contents }));
          try {
            setValue('body', contents, { shouldValidate: true });
          } catch (e) {}
        },
        // Image upload to backend (similar to previous Froala behaviour)
        onImageUpload: function (files) {
          if (!files || !files.length || !api) return;
          const file = files[0];
          const data = new FormData();
          data.append('file', file);

          api
            .call('upload', 'POST', data, true, true)
            .then((res) => {
              if (res.status === 200 && res.data) {
                const url =
                  res.data.url ||
                  res.data.path ||
                  res.data.link ||
                  res.data.file ||
                  (typeof res.data === 'string' ? res.data : '');

                if (url) {
                  $el.summernote('insertImage', url);
                } else {
                  // Fallback to base64 if API does not return a usable URL
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    $el.summernote('insertImage', e.target.result);
                  };
                  reader.readAsDataURL(file);
                }
              }
            })
            .catch(() => {
              // On error, fallback to base64 insert so user is not blocked
              const reader = new FileReader();
              reader.onload = (e) => {
                $el.summernote('insertImage', e.target.result);
              };
              reader.readAsDataURL(file);
            });
        },
      },
    });

    return () => {
      try {
        $el.summernote('destroy');
      } catch (e) {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleToChange = (index, value) => {
    const newTo = [...formData.to];
    newTo[index] = value;
    setFormData(prev => ({
      ...prev,
      to: newTo
    }));
    try { setValue('to', newTo, { shouldValidate: true }); } catch (_) {}
    try { trigger('to'); } catch (_) {}
  };

  const addToEmail = () => {
    setFormData(prev => ({
      ...prev,
      to: [...prev.to, '']
    }));
    try { setValue('to', [...formData.to, ''], { shouldValidate: true }); } catch (_) {}
    try { trigger('to'); } catch (_) {}
  };

  const removeToEmail = (index) => {
    if (formData.to.length > 1) {
      const newTo = formData.to.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        to: newTo
      }));
      try { setValue('to', newTo, { shouldValidate: true }); } catch (_) {}
      try { trigger('to'); } catch (_) {}
    }
  };
  
  const handleTemplateChange = async (templateId, data = formData) => {
    if (templateId) {
      try {
 
        const filters = {
            attachAsPdf: data?.attachments?.copy?.attachAsPdf,
            attachAsExcel: data?.attachments?.copy?.attachAsExcel,
            itemLongText: data?.attachments?.copy?.itemLongText,
            itemQuantity: data?.attachments?.copy?.itemQuantity,
            itemPrice: data?.attachments?.copy?.itemPrice,
            itemTotal: data?.attachments?.copy?.itemTotal,
            grandTotal: data?.attachments?.copy?.grandTotal,
          };
       
        setTempId(templateId);
        const response = await getCommunicationTemplateById(templateId,{'module' : module,'module_id' : moduleData.id,filters,'c_module' : 'send_mail'});
        if (response?.data) {
          const selectedTemplate = response.data;
          setFormData(prev => ({
            ...prev,
            template_id: templateId,
            subject: selectedTemplate.subject || '',
            body: selectedTemplate.body || ''
          }));
          try { setValue('subject', selectedTemplate.subject || '', { shouldValidate: true }); } catch (_) {}
          try { setValue('body', selectedTemplate.body || '', { shouldValidate: true }); } catch (_) {}
          if (summernoteRef.current) {
            try {
              $(summernoteRef.current).summernote('code', selectedTemplate.body || '');
            } catch (e) {}
          }
        }
      } catch (error) {
        console.error('Error fetching template:', error);
        // Fallback to local template if API call fails
        const selectedTemplate = templates.find(t => t.id === templateId);
        if (selectedTemplate) {
          setFormData(prev => ({
            ...prev,
            template_id: templateId,
            subject: selectedTemplate.subject || '',
            body: selectedTemplate.body || ''
          }));
          try { setValue('subject', selectedTemplate.subject || '', { shouldValidate: true }); } catch (_) {}
          try { setValue('body', selectedTemplate.body || '', { shouldValidate: true }); } catch (_) {}
          if (summernoteRef.current) {
            try {
              $(summernoteRef.current).summernote('code', selectedTemplate.body || '');
            } catch (e) {}
          }
        }
      }
    } else {
      // Clear template selection
      setFormData(prev => ({
        ...prev,
        template_id: '',
        subject: '',
        body: ''
      }));
      try { setValue('subject', '', { shouldValidate: true }); } catch (_) {}
      try { setValue('body', '', { shouldValidate: true }); } catch (_) {}
      if (summernoteRef.current) {
        try {
          $(summernoteRef.current).summernote('code', '');
        } catch (e) {}
      }
    }
  };
  
  const handleAttachmentChange = (section, field, value) => {
    
    setFormData(prev => {
        const updated = {
          ...prev,
          attachments: {
            ...prev.attachments,
            [section]: {
              ...prev.attachments[section],
              [field]: value,
            },
          },
        };
    
        if (section === "copy") {
          // use updated instead of stale formData
          handleTemplateChange(tempId, updated);
        }
    
        return updated;
      });
  };

  const handlePicsChange = (picId, checked) => {
    
    setFormData(prev => ({
      ...prev,
      attachments: {
        ...prev.attachments,
        pics: checked 
          ? [...prev.attachments.pics, picId]
          : prev.attachments.pics.filter(id => id !== picId)
      }
    }));
  };

  const handleDocsChange = (docId, checked) => {
    setFormData(prev => ({
      ...prev,
      attachments: {
        ...prev.attachments,
        docs: checked 
          ? [...prev.attachments.docs, docId]
          : prev.attachments.docs.filter(id => id !== docId)
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsSubmitted(true);
    showLoading();
    try {
      const valid = await trigger(['from','to','subject','body']);
      if (!valid) { setLoading(false); hideLoading(); return; }
       
      // Call the onSend function with form data
      await handleSendMailSubmit(formData);
    
    } catch (error) {
      console.error('Error sending email:', error);
    } finally {
      setLoading(false);
      hideLoading()
      
    }
  };

  function ucfirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handleSendMailSubmit = async (data) => {
    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (typeof value === "object") {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });
      formData.append('module',module)
      formData.append('moduleData',JSON.stringify(moduleData))
      formData.append('module_id',moduleData?.id)
      
      const response =  await api.call('send-mail', 'POST', formData, true,true);
      if(response.status === 200){
        Swal.fire({
          title: 'Success!',
          text: ucfirst(module) +' Email sent successfully',
          icon: 'success',
          confirmButtonText: 'OK'
        });
        onClose();
        hideLoading()
        return {'status':response.status};

      }else{
        return handleApiError(response.error, {
          showAlert: true,
          redirectOn401: true,
          customMessage: 'Failed to send email'
        });
      }
     
    } catch (error) {
      console.error('Error sending email:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to send email',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-full md:max-w-6xl h-full max-h-[95dvh] md:max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Send {module} Email</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col md:flex-row flex-1 min-h-0">
          {/* Left Side - Form Fields */}
          <div className="flex-1 p-4 md:p-6 overflow-y-auto scrollbar-thin">
            <div className="space-y-6">
              {/* From Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  From *
                </label>
                <select
                  value={formData.from}
                  onChange={(e) => { handleInputChange('from', e.target.value); try { setValue('from', e.target.value, { shouldValidate: true }); } catch (_) {} }}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.from ? 'border-red-500' : 'border-gray-300'}`}
                >
                  <option value="">Select Workforce Member</option>
                  {workforce.map((member) => (
                    <option key={member.id} value={member.id}>
                      {member.first_name} {member.last_name} ({member.email})
                    </option>
                  ))}
                </select>
                {errors.from && (<p className="mt-1 text-xs text-red-600">{errors.from.message}</p>)}
              </div>

              {/* BCC Me Checkbox */}
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="bccMe"
                  checked={formData.bccMe}
                  onChange={(e) => handleInputChange('bccMe', e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="bccMe" className="ml-2 block text-sm text-gray-700">
                  BCC Me
                </label>
              </div>

              {/* To Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  To *
                </label>
                <div className="space-y-2">
                  {formData.to.map((email, index) => (
                    <div key={index} className="flex flex-col space-y-1">
                      <div className="flex space-x-2">
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => handleToChange(index, e.target.value)}
                          placeholder="abc@example.com"
                          className={`flex-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.to && errors.to[index] ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {formData.to.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeToEmail(index)}
                            className="px-3 py-2 text-red-600 hover:text-red-800"
                          >
                            Remove
                          </button>
                        )}
                      </div>
                      {errors.to && errors.to[index] && (
                        <p className="text-xs text-red-600">{errors.to[index]?.message}</p>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={addToEmail}
                    className="text-sm text-blue-600 hover:text-blue-800"
                  >
                    + Add Another Email
                  </button>
                </div>
              </div>

              {/* Template Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Template
                </label>
                <select
                  value={formData.template_id}
                  onChange={(e) => handleTemplateChange(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Template</option>
                  {templates.map((template) => (
                    <option key={template.id} value={template.id}>
                      {template.name}
                    </option>
                  ))}
                </select>
              </div>
 
                {/* Subject Field */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Subject *
                  </label>
                    <div className={`border rounded-md ${( isSubmitted && errors.subject) ? 'border-red-500' : 'border-gray-300'}` }>
                    <input
                      type="text"
                      value={formData.subject}
                      onChange={(e) => { handleInputChange('subject', e.target.value); try { setValue('subject', e.target.value, { shouldValidate: true }); } catch (_) {} try { trigger('subject'); } catch (_) {} }}
                      className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${ ( errors.subject) ? 'border-red-500' : 'border-gray-300'}`}
                      placeholder='Enter your email subject here...'
                    />
                    
                  </div>
                  {errors.subject && (<p className="mt-1 text-xs text-red-600">{errors.subject.message}</p>)}
                </div>


              {/* Body Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Body *
                </label>
               
                <div className={`border rounded-md ${(isSubmitted && errors.body) ? 'border-red-500' : 'border-gray-300'}` }>
                  <div ref={summernoteRef} />
                  {( isSubmitted && errors.body) && (<p className="mt-1 text-xs text-red-600 px-3 py-1">{errors.body.message}</p>)}
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Attachments */}
          <div className="w-full md:w-80 border-t md:border-t-0 md:border-l border-gray-200 p-4 md:p-6 overflow-y-auto md:overflow-y-auto max-h-[35vh] md:max-h-none shrink-0 scrollbar-thin">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Attachments</h3>

            {/* Tabs for small screens */}
            <div className="md:hidden mb-4">
              <nav className="flex space-x-2" aria-label="Tabs">
                {['copy','pics','docs'].map(tab => (
                  <button
                    key={tab}
                    type="button"
                    className={`px-3 py-1.5 rounded text-sm border ${attachmentsActiveTab === tab ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-white text-gray-700 border-gray-200'}`}
                    onClick={() => setAttachmentsActiveTab(tab)}
                  >
                    {tab.charAt(0).toUpperCase()+tab.slice(1)}
                  </button>
                ))}
              </nav>
            </div>

            {/* Copy Tab */}
            <div className={`${attachmentsActiveTab === 'copy' ? 'block' : 'hidden'} md:block mb-6`}>
              <h4 className="text-sm font-medium text-gray-700 mb-3">Copy</h4>
              <div className="space-y-2">
                <label className="flex items-center">
                    <input
                    type="checkbox"
                    checked={formData.attachments.copy.attachAsPdf}
                    onChange={(e) => handleAttachmentChange('copy', 'attachAsPdf', e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">Attach As PDF</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={formData.attachments.copy.attachAsExcel}
                    onChange={(e) => handleAttachmentChange('copy', 'attachAsExcel', e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">Attach As Excel</span>
                </label>
                
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={formData.attachments.copy.itemLongText}
                    onChange={(e) => handleAttachmentChange('copy', 'itemLongText', e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">Item Long Text</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={formData.attachments.copy.itemQuantity}
                    onChange={(e) => handleAttachmentChange('copy', 'itemQuantity', e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">Item Quantity</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={formData.attachments.copy.itemPrice}
                    onChange={(e) => handleAttachmentChange('copy', 'itemPrice', e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">Item Price</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={formData.attachments.copy.itemTotal}
                    onChange={(e) => handleAttachmentChange('copy', 'itemTotal', e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">Item Total</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={formData.attachments.copy.grandTotal}
                    onChange={(e) => handleAttachmentChange('copy', 'grandTotal', e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-600">Grand Total</span>
                </label>
              </div>
            </div>

          {/* Pics Tab */}
          <div className={`${attachmentsActiveTab === 'pics' ? 'block' : 'hidden'} md:block mb-6`}>
            <h4 className="text-sm font-medium text-gray-700 mb-3">Pics</h4>
            {moduleData?.pictures && moduleData.pictures.length > 0 ? (
              <div className="space-y-3">
                {moduleData.pictures.map((pic) => (
                  <label
                    key={pic.id}
                    className="flex items-center p-2 bg-white rounded-lg shadow-sm hover:shadow-md transition cursor-pointer"
                  >
                    {/* Image on the left */}
                    <a href={pic.url} target="_blank" rel="noopener noreferrer">
                      <img
                        src={pic.url}
                        alt={pic.name}
                        className="w-20 h-20 object-cover rounded-md transition-transform duration-200 hover:scale-105"
                      />
                    </a>

                    {/* Checkbox + Name on the right */}
                    <div className="ml-4 flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={formData.attachments.pics.includes(pic.id)}
                        onChange={(e) => handlePicsChange(pic.id, e.target.checked)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700 truncate max-w-[150px]">
                        {pic.name}
                      </span>
                    </div>
                  </label>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-500">No pictures available</p>
            )}
          </div>


            {/* Docs Tab */}
            <div className={`${attachmentsActiveTab === 'docs' ? 'block' : 'hidden'} md:block mb-6`}>
              <h4 className="text-sm font-medium text-gray-700 mb-3">Docs</h4>
              {(moduleData?.documents || []).concat(moduleData?.selected_docs || []).length > 0 ? (
                <div className="space-y-2">
                  {moduleData?.documents?.map((doc) => (
                    <label key={doc.id} className="flex items-center">
                      <input
                        type="checkbox"
                        checked={formData.attachments.docs.includes(doc.id)}
                        onChange={(e) => handleDocsChange(doc.id, e.target.checked)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="ml-2 text-sm text-gray-600 truncate">{doc.name}</span>
                    </label>
                  ))}
                  {moduleData?.selected_docs?.map((doc) => (
                    <label key={doc.id} className="flex items-center">
                      <input
                        type="checkbox"
                        checked={formData.attachments.docs.includes(doc.id)}
                        onChange={(e) => handleDocsChange(doc.id, e.target.checked)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="ml-2 text-sm text-gray-600 truncate">{doc.name}</span>
                    </label>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-500">No documents available</p>
              )}
            </div>
          </div>
        </form>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-4 md:p-6 border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={loading}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#009efb] hover:bg-[#0089db] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#009efb]"
          >
            {loading ? (
              'Sending...'
            ) : (
              <>
                <PaperAirplaneIcon className="h-4 w-4 mr-2" />
                Send Email
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendMailModal;
